/**
 * Pakiki Header Behavior
 * - Transparent header on homepage, solid on scroll
 * - Hide on scroll down, show on scroll up
 * - Announcement bar visibility handling
 */
(function () {
  'use strict';

  const SCROLL_THRESHOLD = 50;
  const HIDE_THRESHOLD = 100;

  let lastScrollY = 0;
  let ticking = false;

  const headerWrapper = document.querySelector('.header-wrapper');
  const announcementBar = document.querySelector('.announcement-bar-section');
  const isHomepage = document.body.classList.contains('template-index');

  if (!headerWrapper) return;

  // Set initial transparent state on homepage
  if (isHomepage) {
    headerWrapper.classList.add('header-wrapper--transparent');
  }

  function getAnnouncementHeight() {
    if (!announcementBar) return 0;
    return announcementBar.offsetHeight;
  }

  function updateHeader() {
    const currentScrollY = Math.max(0, window.scrollY || window.pageYOffset || 0);
    const announcementHeight = getAnnouncementHeight();

    // Transparent → Solid transition on homepage
    if (isHomepage) {
      if (currentScrollY > 5) {
        headerWrapper.classList.remove('header-wrapper--transparent');
        headerWrapper.classList.add('header-wrapper--scrolled');
        headerWrapper.style.backgroundColor = '#FAF8F2';
      } else {
        headerWrapper.classList.add('header-wrapper--transparent');
        headerWrapper.classList.remove('header-wrapper--scrolled');
        headerWrapper.style.backgroundColor = 'transparent';
      }
    } else {
      headerWrapper.classList.remove('header-wrapper--transparent');
      headerWrapper.style.backgroundColor = '#FAF8F2';
      if (currentScrollY > 5) {
        headerWrapper.classList.add('header-wrapper--scrolled');
      } else {
        headerWrapper.classList.remove('header-wrapper--scrolled');
      }
    }

    // Hide/Show on scroll direction (unless mega menu is open)
    const isMenuOpen = document.querySelector('.pakiki-nav-item.is-open, .pakiki-mega-dropdown:hover');
    if (!isMenuOpen) {
      if (currentScrollY <= announcementHeight) {
        // At or near top — ALWAYS show header and never translate off screen
        headerWrapper.style.transform = 'translateY(0)';
      } else if (currentScrollY > lastScrollY && currentScrollY > HIDE_THRESHOLD) {
        // Scrolling down past threshold — hide header
        headerWrapper.style.transform = 'translateY(-100%)';
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up — show header smoothly
        headerWrapper.style.transform = 'translateY(0)';
      }
    }

    // Adjust header position based on announcement bar (immediate, no CSS transition delay)
    if (currentScrollY <= announcementHeight) {
      headerWrapper.style.top = Math.max(0, announcementHeight - currentScrollY) + 'px';
    } else {
      headerWrapper.style.top = '0';
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  // Initialize
  headerWrapper.style.position = 'fixed';
  headerWrapper.style.left = '0';
  headerWrapper.style.right = '0';
  headerWrapper.style.zIndex = '50';
  headerWrapper.style.transition = 'transform 0.3s ease, background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease';
  if (!isHomepage) {
    headerWrapper.style.backgroundColor = '#FAF8F2';
  }

  // Ensure body padding is NEVER set (setting it pushes announcement bar below header)
  document.body.style.paddingTop = '';

  function updateLayout() {
    const announcementHeight = getAnnouncementHeight();
    const headerHeight = headerWrapper.offsetHeight;

    // Expose CSS variables for layout sync
    document.documentElement.style.setProperty('--announcement-bar-height', announcementHeight + 'px');
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

    // On subpages, offset #MainContent so content is not obscured by fixed header
    const mainContent = document.getElementById('MainContent');
    if (!isHomepage && mainContent) {
      mainContent.style.paddingTop = headerHeight + 'px';
    }

    updateHeader();
  }

  // Set initial positions and heights
  updateLayout();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateLayout, { passive: true });
  window.addEventListener('load', updateLayout);

  // Handle announcement bar visibility changes (e.g., if user closes it or slide height changes)
  if (announcementBar) {
    const observer = new MutationObserver(function () {
      updateLayout();
    });
    observer.observe(announcementBar, { attributes: true, childList: true, subtree: true });
  }
})();
